import CloseImg from "assets/ic_close.png";
import { localPreShowNoticeKey } from "helper/constant";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import SlideUpNotice from "../CommonSlideUp/SlideUpNotice";
import "./notice.scss";

const AppNotice = () => {
  const noticeContent = (
    <>
      <p className="main-title">토스인컴 서비스 이용약관 변경 공지</p>
      <p className="contents">
        안녕하세요. 토스인컴입니다.
        <br />
        2025년 2월 23일부로, 토스인컴의 서비스 이용약관이 변경됨을 공지드립니다.
      </p>
      <p className="title">1. 주요 변경사항 및 개정사유</p>
      <p className="contents">다음과 같은 주요 변경 사항이 적용됩니다:</p>
      <ul className="contents">
        <li>서비스명 변경</li>
        <li>
          서비스 종류 및 내용 변경 (사전 자료 수집 서비스, 세금 환급 일정 알림
          서비스 추가)
        </li>
        <li>회원 자격 정지 조항 삭제</li>
        <li>회원 통지 방법 추가 (문자, 카카오톡, 앱 내 푸시 등)</li>
        <li>서비스 해지 사유 명확화</li>
        <li>중복 조항 통합</li>
      </ul>
      <p className="title">2. 변경전, 후 약관 전문</p>
      <ul className="contents">
        <li>
          <a
            href="https://service.toss.im/terms/5715/revisions/55453"
            target="_blank"
            rel="noopener noreferrer"
          >
            변경 후 약관 보러 가기
          </a>
        </li>
        <li>
          <a
            href="https://thesave.it/policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            변경 전 약관 보러 가기
          </a>
        </li>
      </ul>
      <p className="title">3. 개정일자</p>
      <p className="contents">약관 시행일: 2025년 2월 23일</p>
      <p className="title">4. 이의 제기 관련 사항</p>
      <p className="contents">
        개정 약관에 동의하지 않으시는 경우에는 서비스 해지를 요청하실 수 있으며,
        개정약관 시행일 전까지 별도의 이의를 제기하지 않으실 경우 본 개정 약관에
        동의하시는 것으로 간주됨을 알려드립니다.
      </p>
      <p className="contents">
        금번 약관 개정과 관련하여 궁금하신 사항은 고객센터 (1599-4905, 카카오톡
        아이디:
        <strong>@toss</strong>)로 문의하여 주시기 바랍니다.
      </p>
    </>
  );

  const [noticeOpen, setNoticeOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const preShowNotice = localStorage.getItem(localPreShowNoticeKey);
    let shouldShowNotice = true;

    if (preShowNotice === new Date().toLocaleDateString()) {
      shouldShowNotice = false; // 오늘 이미 숨긴 경우
    }

    setNoticeOpen(shouldShowNotice && location.pathname === "/");
  }, [location]);

  const handleCloseNotice = (dontShowToday) => {
    if (dontShowToday) {
      localStorage.setItem(
        localPreShowNoticeKey,
        new Date().toLocaleDateString(),
      );
    }
    setNoticeOpen(false);
  };

  return (
    <SlideUpNotice
      alignContentBottom={true}
      popupMargin={0}
      isOpen={noticeOpen}
      handleClose={() => {
        setNoticeOpen(false);
      }}
    >
      <div className="notice_container">
        <div className="notice_container_header">
          <div onClick={() => handleCloseNotice(true)}>오늘 하루 보지 않기</div>
          <div onClick={() => handleCloseNotice(false)}>
            <img src={CloseImg} width={12} alt="닫기" />
          </div>
        </div>
        <div className="notice_container_body">{noticeContent}</div>
      </div>
    </SlideUpNotice>
  );
};

export default AppNotice;
